import { makeObservable, observable } from "mobx";

export class ErrorItem {
    public title = "";
    public message = "";
    public isTimeout = false;
    public operation: IErrorOperation;
    @observable public trace?: string = "";
    @observable public time: number = Date.now();
    @observable public count = 1;

    constructor(
        title: string,
        message: string,
        isTimeout: boolean,
        trace: string,
        operation: IErrorOperation
    ) {
        makeObservable(this);

        this.title = title;
        this.message = message;
        this.isTimeout = isTimeout;
        this.trace = trace;
        this.operation = operation;
    }
}

export interface IErrorOperation {
    id?: string;
    name?: string;
    code?: string;
}
